import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plan_template_add_icon",
  "use": "icon-plan_template_add_icon-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-plan_template_add_icon\">\n<path d=\"M192,108H8c-4.4,0-8-3.6-8-8v0c0-4.4,3.6-8,8-8h184c4.4,0,8,3.6,8,8v0C200,104.4,196.4,108,192,108z\" />\n<path d=\"M92,192V8c0-4.4,3.6-8,8-8h0c4.4,0,8,3.6,8,8v184c0,4.4-3.6,8-8,8h0C95.6,200,92,196.4,92,192z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol